import { Table, Alert, Badge } from 'react-bootstrap';

const fmt = (v, d = 2) =>
  Number(v || 0).toLocaleString('ro-RO', { minimumFractionDigits: d, maximumFractionDigits: d });

/**
 * What a length correction is about to change, before anything is written.
 *
 * Shared by both places a drum's length can be corrected — the token modal in
 * project-details and the execution-log editor — so the same edit is reviewed
 * the same way whichever door it comes through.
 *
 * The list is the endpoint's own dry run rather than anything recomputed here:
 * a preview that derived the numbers separately from the code that writes them
 * would eventually disagree with it, which is worse than no preview at all.
 */
const TokenCorrectionPreview = ({ preview }) => {
  if (!preview) return null;

  if (preview.noop) {
    return (
      <Alert variant="info" className="fs-9 mb-0">
        The drum is already recorded at that length — nothing would change.
      </Alert>
    );
  }

  const rows = preview.changes || [];
  const metrics = preview.metricRecords || [];

  return (
    <>
      <h6 className="mb-2 fs-9">
        What changes{' '}
        <Badge bg="secondary" className="fs-10">
          preview
        </Badge>
      </h6>

      <div className="table-responsive mb-3" style={{ maxHeight: 260 }}>
        <Table size="sm" className="fs-9 mb-0">
          <thead>
            <tr className="text-700">
              <th>Field</th>
              <th className="text-end">From</th>
              <th className="text-end">To</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(c => (
              <tr key={c.field}>
                <td style={{ fontFamily: 'monospace', fontSize: '0.75rem' }}>{c.field}</td>
                <td className="text-end">{fmt(c.from)}</td>
                <td className="text-end fw-semibold">{fmt(c.to)}</td>
              </tr>
            ))}

            {metrics.map((m, i) => (
              <tr key={`metric-${i}`}>
                <td style={{ fontFamily: 'monospace', fontSize: '0.75rem' }}>
                  {m.collection} <span className="text-700">(operator totals)</span>
                </td>
                <td className="text-end">{fmt(m.from)}</td>
                <td className="text-end fw-semibold">{fmt(m.to)}</td>
              </tr>
            ))}

            {!rows.length && !metrics.length && (
              <tr>
                <td colSpan={3} className="text-center text-700 py-3">
                  Nothing to change.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {!!preview.warnings?.length && (
        <Alert variant="warning" className="fs-9 mb-0">
          {preview.warnings.map((w, i) => (
            <div key={i}>{w}</div>
          ))}
        </Alert>
      )}
    </>
  );
};

export default TokenCorrectionPreview;
